// Production catalog baseline - Cloudflare Pages
import { LetonData } from '../types';

export const initialLetonData: LetonData = {
  "baristas": [
    {
      "id": "barista-1",
      "name": "Team sudirman",
      "role": "Barista",
      "image": "",
      "order": 1,
      "instagram": "https://instagram.com",
      "description": "Mendedikasikan 6+ tahun mengeksplorasi profil sangrai spesialti dan menjaga konsistensi rasa di setiap cup Leton.",
      "favoriteCoffee": "Leton Aren Signature"
    },
    {
      "id": "barista-2",
      "name": "Azee & MR Bella",
      "role": "Barista Letgo",
      "image": "",
      "order": 2,
      "instagram": "https://instagram.com",
      "description": "Fokus pada ekstraksi presisi dan pouring technique untuk menonjolkan aroma floral dan keasaman manis alami biji kopi nusantara.",
      "favoriteCoffee": "Filter V60 Single Origin"
    },
    {
      "id": "barista-3",
      "name": "Aulia & Indri",
      "role": "Barista & Kasir",
      "image": "",
      "order": 3,
      "instagram": "https://instagram.com",
      "description": "Pecinta kreasi signature drink yang memadukan espresso segar dengan infusi buah tropis dan visual latte art presisi.",
      "favoriteCoffee": "Cyan Ocean Cold Brew"
    },
    {
      "id": "barista-4",
      "name": "Letgo Team",
      "role": "Let'GO Fleet Lead Barista",
      "image": "",
      "order": 4,
      "instagram": "https://instagram.com",
      "description": "Menghadirkan keseruan mobile coffee bar Let'GO ke berbagai festival dan event berkesan di seluruh Dumai.",
      "favoriteCoffee": "Caramel Macchiato Chill"
    },
    {
      "id": "barista-1788235914522",
      "name": "Jenita",
      "role": "Kasir",
      "image": "",
      "order": 5,
      "instagram": "https://instagram.com",
      "description": "Kasir",
      "favoriteCoffee": "Leton Aren Signature"
    },
    {
      "id": "barista-1788236096868",
      "name": "Pojan",
      "role": "Barista",
      "image": "",
      "order": 6,
      "instagram": "https://instagram.com",
      "description": "Barista",
      "favoriteCoffee": "Leton Aren Signature"
    },
    {
      "id": "barista-1788239708233",
      "name": "alex",
      "role": "Barista",
      "image": "",
      "order": 7,
      "instagram": "https://instagram.com",
      "description": "alex",
      "favoriteCoffee": "Leton Aren Signature"
    },
    {
      "id": "barista-1788239754510",
      "name": "Team Sudirman",
      "role": "Barista",
      "image": "",
      "order": 8,
      "instagram": "https://instagram.com",
      "description": "Team sudirman",
      "favoriteCoffee": "Leton Aren Signature"
    }
  ],
  "branches": [
    {
      "id": "chapter-5",
      "badge": "THE URBAN HUB",
      "address": "Jl. Jend. Sudirman No. 88, Dumai Kota, Riau",
      "bgImage": "",
      "mapsUrl": "https://maps.app.goo.gl/eyVVGjG4KKwDJhPq9?g_st=ic",
      "tagline": "Vibrant community scene in the heart of the city",
      "whatsapp": "6281234567890",
      "bgOverlay": 54,
      "branchName": "DUMAI SUDIRMAN",
      "buttonText": "PETUNJUK ARAH & DETAIL",
      "chapterName": "CHAPTER 5",
      "description": "Berlokasi di Jl. Jend. Sudirman No. 88, Dumai Kota, Chapter 5 hadir sebagai salah satu ruang berkumpul yang dekat dengan aktivitas dan kehidupan Masyarat Dumai dan sekitar. Dengan perpaduan suasana modern, nyaman, dan santai, tempat ini dirancang untuk berbagai momen, mulai dari menikmati kopi di sela aktivitas, bertemu teman, berdiskusi, hingga sekadar menghabiskan waktu setelah menjalani kesibukan sehari-hari. Chapter 5 membawa karakter LetonKu yang lebih urban dan dinamis, dengan suasana yang tetap hangat dan welcoming bagi siapa saja yang datang.\n\n\n\nUrban • Modern • Community • Hangout",
      "openingHours": "Setiap Hari: 08:00 – 00.00 WIB",
      "chapterNumber": "02",
      "galleryImages": ["", "", "", ""]
    },
    {
      "id": "chapter-6",
      "badge": "THE CHILL OUT SPOT",
      "address": "Jl. Ratu Sima, Dumai Barat, Riau",
      "bgImage": "",
      "mapsUrl": "https://maps.google.com/?q=Leton+Coffee+Ratu+Sima+Dumai",
      "tagline": "Open-air breeze, cozy seating & late night conversations",
      "whatsapp": "6281234567890",
      "bgOverlay": 64,
      "branchName": "DUMAI RATU SIMA",
      "buttonText": "PETUNJUK ARAH & DETAIL",
      "chapterName": "CHAPTER 6",
      "description": "Berada di kawasan Ratu Sima, Chapter 6 menawarkan pengalaman menikmati kopi dengan suasana yang lebih rileks dan terbuka. Ruang yang nyaman membuat tempat ini cocok untuk menikmati sore bersama teman, berbincang santai, menghabiskan waktu setelah aktivitas, maupun menikmati suasana malam Dumai. Dengan nuansa open-space yang lebih leluasa dan suasana yang dekat dengan komunitas, Chapter 6 menjadi pilihan bagi mereka yang ingin menikmati kopi tanpa terburu-buru sambil menikmati obrolan dan momen bersama orang-orang terdekat.",
      "openingHours": "Setiap Hari: 08:00 – 23:00 WIB",
      "chapterNumber": "03",
      "galleryImages": ["", "", "", "", "", ""]
    }
  ],
  "menuItems": [
    {
      "id": "menu-1",
      "name": "Black Series",
      "badge": "BESTSELLER",
      "image": "",
      "order": 1,
      "price": 30000,
      "categoryId": "fruity",
      "description": "Espresso ganda berpadu dengan susu creamy segar dan sirup aren organik khas Leton.",
      "isAvailable": true
    },
    {
      "id": "menu-2",
      "name": "Ice Milk Coffee Botolan Seriess",
      "badge": "SIGNATURE",
      "image": "",
      "order": 2,
      "price": 20000,
      "categoryId": "signature",
      "description": "Coffe Milk, With Brown Sugar",
      "isAvailable": true
    },
    {
      "id": "menu-3",
      "name": "Fruity Series",
      "image": "",
      "order": 3,
      "price": 25000,
      "categoryId": "fruity",
      "description": "Mocktail With Fruity Seriess",
      "isAvailable": true
    },
    {
      "id": "menu-4",
      "name": "Ice Milk Coffe",
      "image": "",
      "order": 4,
      "price": 18000,
      "categoryId": "coffee",
      "description": "Milk Coffee With Palm Sugar Signature menu",
      "isAvailable": true
    },
    {
      "id": "menu-5",
      "name": "Thai Tea",
      "badge": "Bets seller",
      "image": "",
      "order": 5,
      "price": 20000,
      "categoryId": "non-coffee",
      "description": "Thaitea with Freshmilk",
      "isAvailable": true
    },
    {
      "id": "menu-6",
      "name": "Lycie Tea",
      "badge": "POPULAR",
      "image": "",
      "order": 6,
      "price": 26000,
      "categoryId": "non-coffee",
      "description": "Black Tea with lycie fruit",
      "isAvailable": true
    },
    {
      "id": "menu-7",
      "name": "Main Course",
      "image": "",
      "order": 7,
      "price": 30000,
      "categoryId": "food",
      "description": "",
      "isAvailable": true
    },
    {
      "id": "menu-8",
      "name": "Donut Glaze",
      "image": "",
      "order": 8,
      "price": 26000,
      "categoryId": "food",
      "description": "",
      "isAvailable": true
    }
  ],
  "aboutContent": {
    "badge": "OUR STORY",
    "facts": [
      { "id": "f1", "label": "Cabang & Mobile Truck", "value": "3 Lokasi" },
      { "id": "f2", "label": "Established Coffee Brand", "value": "Since 2020" },
      { "id": "f3", "label": "Komunitas & Event Aktif", "value": "85+" },
      { "id": "f4", "label": "Specialty Beans Quality", "value": "100% Arabica" }
    ],
    "title": "MORE THAN JUST COFFEE.",
    "subtitle": "A COMMUNITY CULTURE BUILT ON PASSION & YOUTH SPIRIT",
    "mainImage": "",
    "description": "LetonKu bermula dari sebuah ide sederhana: bagaimana secangkir kopi berkualitas tinggi dapat menjadi titik temu untuk percakapan jujur, pertukaran ide kreatif, dan ruang bertumbuh bagi anak muda.",
    "sliderImages": ["", "", "", "", "", "", ""],
    "secondaryImage": "",
    "secondaryDescription": "Dari Chapter 5 di Sudirman hingga Chapter 6 di Ratu Sima dan armada mobile Let'GO, kami terus berkomitmen menyajikan biji kopi pilihan terbaik dari petani Nusantara dengan teknik seduh presisi dan keramahan yang tulus."
  },
  "siteSettings": {
    "logoUrl": "",
    "tagline": "LETONKU DUMAI",
    "brandName": "LETONKU",
    "heroTitle": "Bridging Your Desire of Coffee",
    "heroBgImage": "",
    "heroSubtitle": "DUMAI'S FAVORITE COFFEE SCENE",
    "heroCtaMenuText": "EXPLORE MENU",
    "heroDescription": "Ruang temu semua kalangan dengan sajian kopi spesialti berkarakter, atmosfer dinamis, dan semangat komunitas kreatif tanpa batas.",
    "heroCtaOrderText": "ORDER VIA WHATSAPP"
  },
  "mobileService": {
    "badge": "MOBILE COFFEE EXPERIENCE",
    "title": "LET'GO",
    "bgImage": "",
    "ctaText": "BOOK FOR EVENT",
    "features": [
      "Custom Branded Cups & Sleeves",
      "Full Specialty Espresso Bar",
      "High Capacity: 500+ Cups / Day",
      "Signature Mocktails & Non-Coffee"
    ],
    "subtitle": "LETONKU ON THE MOVE",
    "whatsapp": "6281234567890",
    "bgOverlay": 39,
    "eventInfo": "Melayani Wedding, Corporate Gathering, Music Concert, Birthday Party, Sports Event, hingga Community Meetup.",
    "locations": ["Parkiran MPP", "Ecopark"],
    "truckImage": "",
    "description": "Let On Go (Let’Go) merupakan konsep mobile coffee dari LetonKu yang membawa pengalaman menikmati kopi keluar dari ruang coffee shop dan lebih dekat dengan aktivitas masyarakat.",
    "serviceArea": "Area Jangkauan: Dumai Kota, Bukit Kapur, Sungai Sembilan, hingga Pekanbaru.",
    "serviceInfo": "Unit mobile truck estetik dengan mesin espresso komersial, generator independen, dan barista profesional berpengalaman.",
    "galleryImages": ["", "", "", "", ""],
    "openBoothTitle": "LETON OPEN BOOTH",
    "whatsappMessage": "Halo LetonKu, saya tertarik menggunakan layanan Let’GO untuk event.",
    "openBoothBgImage": "",
    "openBoothSubtitle": "HADIR DI AREA PUBLIK",
    "letGoGalleryImages": ["", "", "", "", "", ""],
    "openBoothBgOverlay": 45,
    "openBoothDescription": "Leton Open Booth adalah bagian dari konsep mobile LetonKu yang hadir secara langsung di area publik dan lokasi tertentu."
  },
  "menuCategories": [
    { "id": "signature", "name": "SIGNATURE", "order": 1 },
    { "id": "coffee", "name": "COFFEE SERIES", "order": 2 },
    { "id": "fruity", "name": "FRUITY & MOCKTAIL", "order": 3 },
    { "id": "non-coffee", "name": "NON-COFFEE", "order": 4 },
    { "id": "food", "name": "FOOD & SNACKS", "order": 5 }
  ],
  "baristasContent": {
    "badge": "06 — THE ARTISAN TEAM",
    "title": "MEET OUR BARISTAS",
    "subtitle": "THE CRAFTSMEN, ROASTERS & CREATIVE BREWERS",
    "description": "Di balik setiap tegukan kopi Leton, ada dedikasi, keahlian teknik seduh, dan senyuman hangat dari tim barista kami yang siap menemani hari dan obrolanmu."
  },
  "contactSettings": {
    "email": "halo@letoncoffee.com",
    "title": "LET'S GET COFFEE.",
    "address": "Dumai, Riau — Indonesia",
    "subtitle": "Kunjungi Chapter kami, undang Let'GO truck ke eventmu, atau pesan langsung ke meja/rumahmu.",
    "whatsapp": "6281295120045",
    "footerText": "© 2026 LetonKu. Seluruh hak cipta dilindungi. Proudly brewed for the youth culture.",
    "ctaMapsText": "PETUNJUK GOOGLE MAPS",
    "instagramUrl": "https://instagram.com/letoncoffee",
    "openingHours": "Senin – Minggu: 08:00 – 23:30 WIB",
    "googleMapsUrl": "https://maps.google.com/?q=Leton+Coffee+Dumai",
    "ctaWhatsappText": "CHAT VIA WHATSAPP",
    "ctaInstagramText": "FOLLOW INSTAGRAM",
    "instagramUsername": "@letoncoffee"
  },
  "promoBanners": [
    {
      "id": "banner-1",
      "imageUrl": "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?auto=format&fit=crop&w=1200&q=80",
      "title": "Welcome to LetonKu",
      "subtitle": "Dumai's First Specialty Roaster & Cafe",
      "sortOrder": 1,
      "isActive": true
    },
    {
      "id": "banner-2",
      "imageUrl": "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=1200&q=80",
      "title": "Artisan Coffee & Mocktail",
      "subtitle": "Nikmati kesegaran racikan pesisir modern",
      "sortOrder": 2,
      "isActive": true
    },
    {
      "id": "banner-3",
      "imageUrl": "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&w=1200&q=80",
      "title": "Order Online & Dine-In",
      "subtitle": "Pesan langsung dari mejamu dengan cepat dan mudah",
      "sortOrder": 3,
      "isActive": true
    }
  ],
  "pwaOnboardingSlides": [
    {
      "id": "slide-1",
      "order": 1,
      "image": "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?auto=format&fit=crop&w=1200&q=80",
      "title": "Nikmati Kopi Spesialti Asli Dumai",
      "description": "Biji kopi pilihan nusantara yang disangrai dengan presisi untuk menghadirkan aroma dan cita rasa terbaik di setiap cangkir.",
      "enabled": true
    },
    {
      "id": "slide-2",
      "order": 2,
      "image": "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=1200&q=80",
      "title": "Pesan Mudah & Kumpulkan Poin",
      "description": "Pesan langsung dari mejamu, kumpulkan loyalty point, dan nikmati berbagai reward eksklusif member LetonKu.",
      "enabled": true
    },
    {
      "id": "slide-3",
      "order": 3,
      "image": "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&w=1200&q=80",
      "title": "Kunjungi Outlet & Nikmati Suasananya",
      "description": "Temukan Chapter 5 Sudirman, Chapter 6 Kelakap 7, atau layanan Let'GO Mobile Coffee di kotamu.",
      "enabled": true
    }
  ],
  "specialForYou": [
    {
      "id": "promo-senja-bundling",
      "product_id": "menu-1",
      "title": "Paket Senja Kopi & Croissant",
      "description": "Kombinasi sempurna Black Series espresso ganda dengan susu creamy segar dan sirup aren organik khas LetonKu.",
      "image_url": "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?auto=format&fit=crop&w=1200&q=80",
      "price": 30000,
      "display_order": 1,
      "is_active": true,
      "discount_info": "Harga Spesial Paket + Bonus Poin Loyalty",
      "terms_and_conditions": "• Berlaku untuk pemesanan Dine In, Take Away, dan Delivery.\n• Berlaku setiap hari selama jam operasional outlet.\n• Tidak dapat digabungkan dengan promo voucher lainnya.\n• Poin loyalty akan otomatis ditambahkan ke akun member Anda.",
      "start_date": "1 Nov 2025",
      "end_date": "31 Des 2026",
      "badge_text": "BEST VALUE",
      "created_at": "2025-11-01T00:00:00.000Z",
      "updated_at": "2025-11-01T00:00:00.000Z"
    },
    {
      "id": "promo-delivery-pertama",
      "product_id": "menu-3",
      "title": "Diskon Delivery Spesial LetonKu",
      "description": "Nikmati kesegaran Fruity Series Mocktail favorit langsung diantar ke depan pintumu oleh Kurir Resmi LetonKu.",
      "image_url": "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=1200&q=80",
      "price": 25000,
      "display_order": 2,
      "is_active": true,
      "discount_info": "Promo Menu Favorit Delivery Resmi LetonKu",
      "terms_and_conditions": "• Khusus metode pemesanan Delivery melalui aplikasi web PWA LetonKu.\n• Berlaku untuk outlet Chapter 5 Sudirman & Chapter 6 Kelakap 7.\n• Berlaku untuk semua pelanggan terdaftar.",
      "start_date": "1 Nov 2025",
      "end_date": "31 Des 2026",
      "badge_text": "PROMO DELIVERY",
      "created_at": "2025-11-01T00:00:00.000Z",
      "updated_at": "2025-11-01T00:00:00.000Z"
    },
    {
      "id": "promo-fruity-buy2get1",
      "product_id": "menu-6",
      "title": "Weekend Refresh: Lycie Tea Special",
      "description": "Kesegaran Black Tea pilihan dengan buah leci asli yang manis dan menyegarkan untuk menemani akhir pekanmu.",
      "image_url": "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?auto=format&fit=crop&w=1200&q=80",
      "price": 26000,
      "display_order": 3,
      "is_active": true,
      "discount_info": "Menu Favorit Akhir Pekan + Poin Member",
      "terms_and_conditions": "• Berlaku setiap hari di seluruh outlet LetonKu.\n• Berlaku untuk pemesanan Dine In, Take Away, dan Delivery.\n• Selama persediaan masih ada.",
      "start_date": "1 Nov 2025",
      "end_date": "31 Des 2026",
      "badge_text": "POPULAR",
      "created_at": "2025-11-01T00:00:00.000Z",
      "updated_at": "2025-11-01T00:00:00.000Z"
    }
  ]
} as unknown as LetonData;
